import ScrollOut from 'scroll-out';

export default function() {

    var isAboutPage = document.querySelector('body.about');

    if(isAboutPage) {
        ScrollOut({
            // once: true,
            cssProps: {
                visibleY: true,
                viewportY: true
            },
        });

    } else {
        ScrollOut({
            once: true
        });
    }


    //
    // var image = document.querySelector('.sectioned-points img.image');
    //
    // if(image) {
    //     window.addEventListener('scroll', function() {
    //         if(window.innerWidth > 1444) {
    //             var scrollPosition = window.scrollY;
    //             image.style.transform = 'translate(-50%, ' + (-scrollPosition * 0.08) + 'px)';
    //         }
    //
    //     });
    // }

}